/**
 * Get the strength label based on the provided result.
 *
 * @param {number} result - The result value to determine the strength label.
 * @returns {string} The strength label (Low, Fair, Moderate, Strong, or Unknown Strength).
 */
export const getResultStrenght = result => {
  let resultStrenght = '';

  if (result < 40) {
    resultStrenght = 'Low';
  } else if (result >= 40 && result < 60) {
    resultStrenght = 'Fair';
  } else if (result >= 60 && result < 75) {
    resultStrenght = 'Moderate';
  } else if (result >= 75 && result <= 100) {
    resultStrenght = 'Strong';
  } else {
    resultStrenght = 'Unknown Strength';
  }

  return resultStrenght;
};
